module.exports = __webpack_public_path__ + "static/media/iconQuestionMark.170ad1b2.svg";